var _defs, _path, _g, _ellipse, _g2, _path2, _g3, _ellipse2, _g4, _path3, _g5, _ellipse3, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9e3612;}.cls-2{fill:#d67347;}.cls-3{fill:#ad4112;}.cls-4{clip-path:url(#clip-path);}.cls-5,.cls-7,.cls-8{fill:none;stroke-linecap:round;stroke-miterlimit:10;}.cls-5{stroke:#d67347;}.cls-5,.cls-7{stroke-width:3px;}.cls-6{clip-path:url(#clip-path-2);}.cls-7,.cls-8{stroke:#000;}.cls-8{stroke-width:2px;}.cls-9{clip-path:url(#clip-path-3);}.cls-10{fill:#fff;}.cls-11{clip-path:url(#clip-path-4);}.cls-12{clip-path:url(#clip-path-5);}.cls-13{clip-path:url(#clip-path-6);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.78,512.84H786.4c76.46,0,140.55,58.39,146.92,134.58q.55,6.55.75,13.51c2.17,78.64-59.42,144.46-137.92,149.54L200.78,849Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 200.78,
    cy: 680.93,
    rx: 110.1,
    ry: 168.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M446.54,257.25h585.62c76.46,0,140.55,58.39,146.92,134.58.36,4.37.62,8.87.74,13.52C1182,484,1120.4,549.8,1041.91,554.89L446.54,593.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 446.54,
    cy: 425.35,
    rx: 110.1,
    ry: 168.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.75,539.94h585.63c76.45,0,140.55,58.39,146.91,134.58q.56,6.56.75,13.52c2.18,78.63-59.42,144.45-137.92,149.54L607.75,876.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 607.75,
    cy: 708.04,
    rx: 110.1,
    ry: 168.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.78,512.84H786.4c76.46,0,140.55,58.39,146.92,134.58q.55,6.55.75,13.51c2.17,78.64-59.42,144.46-137.92,149.54L200.78,849Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M311,555.71a201.94,201.94,0,0,1,13.52,228.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414,857.53A373.31,373.31,0,0,1,595.29,509.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M453.07,854.81c3.31-70.79,40.68-139.21,98.45-180.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329.55,496.9c47.5,70.49,67.54,159,55.05,243.06-6.7,45-24.49,91.48-61.86,117.49"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 200.78,
    cy: 680.93,
    rx: 110.1,
    ry: 168.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 188,
    cy: 671.83,
    rx: 35.77,
    ry: 61.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120.49,727.2a139.66,139.66,0,0,1,11.18-112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M289.24,642.82A156.17,156.17,0,0,1,276.9,767.63"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M446.54,257.25h585.62c76.46,0,140.55,58.39,146.92,134.58.36,4.37.62,8.87.74,13.52C1182,484,1120.4,549.8,1041.91,554.89L446.54,593.44Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M985.17,219.69c9.6,50.7,50.88,94,101.07,106s106.56-8,138-48.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M898.45,241.16c5.19,26.16,23.12,48.24,44.07,64.73s45.07,28.36,68.07,41.84a541.4,541.4,0,0,1,184.67,179.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M562.93,290.27c46.06,71,46.2,169.1.36,240.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M616.53,222.09c25.63,45.13,34,97.84,39.53,149.44s9,104.13,26.17,153.11S733,619.7,781.51,638.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M693.75,244.2c-5.21,53.91,19.62,106.75,52.83,149.55S821.42,472,857.51,512.38,925,600.52,931,654.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M860,228.52c-4.63,34,17.45,66,42.44,89.59s54.48,43.46,72.4,72.77c22.72,37.16,23.2,83.27,23,126.82q-.28,63.51-.56,127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M924.42,547.7c-3.06-25.89-22.5-46.59-42.32-63.54s-41.75-33.06-53.21-56.48c-10.84-22.14-10.81-47.83-10.56-72.48q1-95.51,2-191"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M723.86,545.67c2.54-22.06,25.2-38.17,47.4-38.17s42.76,13.09,57,30.1,23.22,37.73,32,58.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 637.89,
    y1: 521.87,
    x2: 1069.89,
    y2: 512.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1041.93,272.62c-6.32,1-13.69,5.05-13.06,11.42.47,4.73,5.46,7.86,10.19,8.36s9.45-.85,14.19-1.27c3.64-.31,7.49,0,10.59,1.91s5.16,5.85,4.05,9.32-4.75,5.34-8.21,6.34-7.19,1.52-10.09,3.66-4.45,6.71-2,9.35c2.19,2.35,6.09,1.79,8.93.3s5.34-3.76,8.46-4.48c6.35-1.46,12.18,3.94,15.7,9.42s6.54,11.94,12.46,14.67c6.19,2.86,14,.34,18.33-4.94s5.36-12.7,3.92-19.36-5.13-12.64-9.46-17.89C1091.27,281.62,1065.45,269,1041.93,272.62Z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 446.54,
    cy: 425.35,
    rx: 110.1,
    ry: 168.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 439.77,
    cy: 425.35,
    rx: 33.94,
    ry: 61.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M375.08,452.83c-12.62-34.12-6.27-74.59,16.19-103.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M539.09,380.75a121.36,121.36,0,0,1-2.41,86.05"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.75,539.94h585.63c76.45,0,140.55,58.39,146.91,134.58q.56,6.56.75,13.52c2.18,78.63-59.42,144.45-137.92,149.54L607.75,876.14Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1334.46,606.18c-47.24,25.05-81.35,73.44-89.07,126.35s11.14,109,49.25,146.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1250.31,536.38a349.88,349.88,0,0,1-54.24,187.14c-21.72,34.18-49.4,64.56-68.16,100.45s-27.58,80.44-9.21,116.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1164.3,522.89C1168.92,573.42,1150,623,1128,668.75S1080.33,759.34,1070,809s-2.17,106.77,35,141.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M800.07,868.84c12.58-55.12,69.24-96.51,125.58-91.72s105.21,55.15,108.3,111.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1055.67,868.06a316.78,316.78,0,0,1-24.8-152.58c2.8-32.23,10.56-63.93,12.42-96.23s-2.89-66.55-22.37-92.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M829.37,549.69c15.87,34.36,55.44,56.1,93,51.07s70-36.42,76.22-73.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M886.76,547.1c9.16,13,28,18.16,42.53,11.53s23-24.28,19.05-39.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M793,514.26c24.72,138-16.45,286.34-108.76,391.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M836.42,650.37A475.11,475.11,0,0,1,726.8,904.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1306.72,667.67a136.84,136.84,0,0,1-89.18,149.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M729.57,605.33c34.84,67.55,33.85,152.34-2.55,219"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 607.75,
    cy: 708.04,
    rx: 110.1,
    ry: 168.1
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 591.53,
    cy: 725.45,
    rx: 34.89,
    ry: 66.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M607.12,811.6a87.38,87.38,0,0,0,44.71-101.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M540.42,663.18a43.27,43.27,0,0,1,34.64-30.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M655.54,580.1c43.75,50.51,56.57,125.85,32,188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects07);
export default __webpack_public_path__ + "static/media/objects-07.2bf69ca0064902c10c116343b078f957.svg";
export { ForwardRef as ReactComponent };